export default __webpack_public_path__ + "static/media/GT-America-Mono-Regular.43c054e1.eot";